<template>
  <div class="steps2-content">
    <div>
      <div>
        <span>输入手机号：</span>
        <input type="text" v-model="phone" />
      </div>
      <div>
        <span>输入验证码：</span>
        <input type="text" v-model="code" />
        <span @click="getCode">{{
          resetCode ? `${countdown} s` : '获取验证码'
        }}</span>
      </div>
      <div @click="handleSubmit">确定</div>
    </div>
    <div></div>
    <div>
      <div>
        <span></span>
        <span>操作说明</span>
      </div>
      <div>1、关联账号手机号码进行验证码获取确认更改.</div>
      <div>2、验证码输入错误时提示“请输入正确的验证码”.</div>
      <div>3、确认阿里云账号后申请短信模板.</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Steps2',
  props: ['toNext'],
  data() {
    return {
      phone: '',
      code: '',
      resetCode: false,
      countdown: 60,
      timer: null
    }
  },
  methods: {
    handleSubmit() {
      this.toNext()
    },
    getCode() {
      if (this.resetCode) return
      this.resetCode = true
      this.runCountdown()
    },
    runCountdown() {
      this.countdown -= 1
      clearTimeout(this.timer)
      if (this.countdown <= 0) {
        this.resetCode = false
        this.countdown = 60
        return
      }
      this.timer = setTimeout(() => {
        this.runCountdown()
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.steps2-content {
  display: flex;
  justify-content: center;
  align-items: center;
  > div:first-child {
    > div {
      > span {
        display: inline-block;
      }
      > span:first-child {
        width: 100px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        text-align: right;
        margin-right: 20px;
      }
      > input {
        outline: none;
        border: none;
        background: none;
      }
    }
    > div:first-child {
      margin-bottom: 23px;
      > input {
        width: 233px;
        height: 30px;
        border: 1px solid #0345ad;
      }
    }
    > div:nth-child(2) {
      margin-bottom: 43px;
      > input {
        width: 118px;
        height: 30px;
        border: 1px solid #0345ad;
        margin-right: 20px;
      }
      > span:last-child {
        width: 95px;
        height: 30px;
        background: linear-gradient(90deg, #105abf 0%, #486dee 100%);
        border-radius: 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }
    }
    > div:last-child {
      width: 152px;
      height: 38px;
      background: linear-gradient(90deg, #105abf 0%, #486dee 100%);
      border-radius: 19px;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      margin: 0 auto;
    }
  }
  > div:nth-child(2) {
    width: 0;
    height: 337px;
    border-left: 2px dashed #c6c6c6;
    margin: 0 124px 0 174px;
  }
  > div:last-child {
    > div:first-child {
      margin-bottom: 32px;
      > span:first-child {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #d00d0d;
        border-radius: 50%;
        margin-right: 6px;
        vertical-align: center;
      }
    }
    > div:not(div:first-child) {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 30px;
    }
  }
}
</style>
